import React, { useState, useRef, useEffect} from 'react';
import { getData, postData } from "../../../../ApiServices/ApiService";
import {ORG_PROGRESS_CARD_REPORT_GENERATE, ORG_CLIENT_SEARCH_TO_ADD_GROUPMEMBER} from '../../../../ApiServices/BaseURL';

const GenerateProgressReportController = ()=>{
    const [reportName, setReportName] = useState(null);
    const [clientName, setClientName] = useState("");
    const [status, setStatus] = useState(null);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");

    const[generateReportLoading, setGenerateReportLoading] = useState(false);
    const [generateReportError, setGenerateReportError] = useState("");
    const [generateReportSuccess, setGenerateReportSuccess] = useState("");
    const [reportNameError, setReportNameError] = useState('');

    const downloadFile = (url) => {
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Schedule Report.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const generateProgressReport = async () => {
            try {
                setGenerateReportError('');
                setGenerateReportLoading(true);
                setGenerateReportSuccess('');
                setReportNameError('');
                if(!selectedEmployee?.client_id && !reportName && !status && !startDate && !endDate){
                    setGenerateReportError('Please fill at least one field to search');
                    return;
                  }
                  if(!reportName){
                    setReportNameError('Please select report name');
                    return
                  }
                  if(startDate > endDate){
                    setGenerateReportError('Start date should be less than end date');
                    return
                  }
                // setCurrentPage(1);
                // setTeamInfo({});
                const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
                const payLoad = {
                  emp_id: storedUserInfo?.emp_id,
                  client_id: selectedEmployee?.client_id,
                //   client_name: searchUser || '',
                report_name: reportName.value || '',
                statsCode: status.value || 0,
                start_date: startDate || '',
                end_date: endDate || ''
                }
                console.log("payLoad in progress card report", payLoad)
                // return
                // Make the API call
                const response = await postData(ORG_PROGRESS_CARD_REPORT_GENERATE, payLoad);
                const responseData = await response.json();
    
                // Check for success (200) and internal status code
                if (response?.status === 200) {
                    if (responseData?.statusCode === 200) {
                        if (responseData?.message.toLowerCase() === 'success') {
                            if (responseData?.dataJ?.length > 0) {
                                setGenerateReportSuccess(responseData?.info);
                                const downloadUrl = responseData.dataJ[0]?.download_url;
                                    console.log("Download URL:", downloadUrl);
                                    downloadFile(downloadUrl);
                                    resetFilter();
                                    setTimeout(() => {
                                        setGenerateReportSuccess('');
                                    }, 3000);
                            } else {
                                setGenerateReportError(responseData?.info || 'Data Not Found');
                            }
                        } else {
                            setGenerateReportError(responseData?.info || 'Failed to fetch Team Information. Please try again.');
                        }
                    } else {
                        setGenerateReportError(responseData?.info || 'Failed to fetch Team Information.');
                    }
                }
                // Token-related errors: 400, 401, 403
                else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                    if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                        setGenerateReportError('Unauthorized access. Your session may have expired. Please log in again.');
                        // Optionally, redirect to the login page or refresh the token
                        // Example: redirectToLogin();
                    } else {
                        setGenerateReportError(responseData?.info || 'Bad request. Please check the request parameters.');
                    }
                }
                // Internal Server Error: 500
                else if (response?.status === 500) {
                    setGenerateReportError(responseData?.info || 'Internal Server Error. Please try again later.');
                }
                // Unexpected or network-related errors
                else {
                    setGenerateReportError('Unexpected error occurred. Please try again later.');
                }
            } catch (error) {
                // Handle various error scenarios
                if (error.response) {
                    // Server responded with a status outside the 2xx range
                    setGenerateReportError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to fetch Team Information. Please try again.'}`);
                } else if (error.request) {
                    // Request was made but no response was received
                    setGenerateReportError('No response received from the server. Please check your network connection and try again.');
                } else {
                    // An error occurred in setting up the request
                    setGenerateReportError(`Failed to fetch Team Information. Please check your network connection and try again.`);
                }
            } finally {
                setGenerateReportLoading(false);
                // showFilter();
            }
        }

        const [searchUser, setSearchUser] = useState('');
        const [error, setError] = useState('');
        const [employeeList, setEmployeeList] = useState([]);
        const [clientSearchError, setClientSearchError] = useState('');
        const [employeesListLoading, setEmployeeListLoading] = useState(false)
            const handleSearchEmployee = async () => {
        
                try {
                    setError('');
                    setClientSearchError('');
                    if (!searchUser) {
                        setClientSearchError('Please enter valid text'); return;
                    }
                    setEmployeeListLoading(true);
                    const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
                    const payLoad = { emp_id_auth: storedUserInfo?.emp_id, search_type: "GENERIC", search_word: searchUser }
        
                    //console.log('handleSearchEmployee payload', payLoad);
                    // Make the API call
                    const response = await postData(ORG_CLIENT_SEARCH_TO_ADD_GROUPMEMBER, payLoad);
                    const responseData = await response.json();
                    //console.log('response Data', responseData);
        
                    // Check for success (200) and internal status code
                    if (response?.status === 200) {
                        if (responseData?.statusCode === 200) {
                            if (responseData?.message.toLowerCase() === 'success') {
                                // setAddEmployeeError('')
                                setEmployeeList(responseData?.dataJ || []);
                                //   setError(responseData?.info);
                                setTimeout(() => {
                                    // handleClose();
                                    // onValueChange();
                                }, 2000);
                            } else {
                                setError(responseData?.info || 'Failed to fetch inventory data. Please try again.');
                            }
                        } else {
                            setError(responseData?.info || 'Failed to fetch Task Categorie data.');
                        }
                    }
                    // Token-related errors: 400, 401, 403
                    else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                        if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                            setError('Unauthorized access. Your session may have expired. Please log in again.');
                            // Optionally, redirect to the login page or refresh the token
                            // Example: redirectToLogin();
                        } else {
                            setError(responseData?.info || 'Bad request. Please check the request parameters.');
                        }
                    }
                    // Internal Server Error: 500
                    else if (response?.status === 500) {
                        setError(responseData?.info || 'Internal Server Error. Please try again later.');
                    }
                    // Unexpected or network-related errors
                    else {
                        setError('Unexpected error occurred. Please try again later.');
                    }
                } catch (error) {
                    // Handle various error scenarios
                    if (error.response) {
                        // Server responded with a status outside the 2xx range
                        setError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to fetch Task Categorie data. Please try again.'}`);
                    } else if (error.request) {
                        // Request was made but no response was received
                        setError('No response received from the server. Please check your network connection and try again.');
                    } else {
                        // An error occurred in setting up the request
                        setError(`Failed to fetch Task Categorie data. Please check your network connection and try again.`);
                    }
                } finally {
                    setEmployeeListLoading(false);
                }
        
                // onValueChange(teamData);
                // onClose();
            };

            const [selectedEmployee, setSelectedEmployee] = useState(null);
    const handleSearchInputChange = (value) => {
        setSearchUser(value);
        if (!value) {
            setSelectedEmployee(null)
        }
    }
    const handleSelectedEmployee = (employee) => {
        setSelectedEmployee(employee);
        setSearchUser(employee?.client_name);

        setEmployeeList([]); // Clear the dropdown
    };

    const resetFilter = ()=>{
        setReportName('');
        setStartDate('');
        setEndDate('');
        setSearchUser('');
        setSelectedEmployee(null);
        setClientSearchError('');
        setError('');
        setGenerateReportError('');
        setReportNameError('');
        setStatus('');
      }

    return{
        reportName,
        setReportName,
        clientName,
        setClientName,
        status,
        setStatus,
        startDate,
        setStartDate,
        endDate,
        setEndDate,
        generateReportSuccess,
        generateReportError,
        generateReportLoading,
        handleSearchEmployee,
        employeesListLoading,
        clientSearchError,
        employeeList,
        error,
        selectedEmployee,
        handleSearchInputChange,
        handleSelectedEmployee,
        searchUser,
        generateProgressReport,
        resetFilter,
        reportNameError
    }
}

export default GenerateProgressReportController